import { Skeleton } from "antd"
import React from "react"

const SkeletonData = ({ loading, children }: { loading: boolean, children?: React.ReactNode }) => (
    loading ? <Skeleton active /> : <> {children} </>
)

export default SkeletonData